import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import EditorContainer from "../../common/EditorContainer";
import StringEditor from "../../common/EditorContainer/StringEditor/StringEditor";

const editorStyle = {
  border: "1px solid rgba(0, 0, 0, 0)",
  borderRadius: "4px",
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "17px",
  fontWeight: 500,
  lineHeight: "25.5px",
  minHeight: "1.5em",
  padding: "4px",
  "&:hover": { backgroundColor: '#f0f0f0', cursor: "text", },
  "&.MuiBox-root": { minHeight: "1.5em", padding: "0px", border: "0px", },
  "&.MuiInputBase-root": { border: "1px solid rgba(0, 0, 0, 0.5)", },
  "& .MuiTypography-root": { whiteSpace: "pre-wrap", },
};

const NameField = ({ disabled, enableEdit, onChange, onDirty, reset, sx, value }) => {
  const [state, setState] = useState({
    dirty: false,
    editValue: value,
  });

  const hasChanged = (newValue) => newValue !== value;

  const handleChange = (newValue) => {
    
    const changed = hasChanged(newValue);
    setState((prev) => ({
      ...prev,
      dirty: changed,
      editValue: newValue,
    }));

    if (state.dirty !== changed) {
      onDirty?.({ dirty: changed });      
    }

    if (changed) {
      onChange?.({ value: newValue });
    }
  };

  useEffect(() => {
    if (reset) {
      setState({
        dirty: false,
        editing: false,
        editValue: value,
      });
    }
  }, [reset, value]);

  return (
    <EditorContainer
      component={StringEditor}
      disabled={disabled}
      enableEdit={enableEdit} //TODO: Check this
      fullWidth
      multiline
      onChange={handleChange} //TODO: Will save direct onChange
      placeholder={<FormattedMessage id="project.placeholder.task.name" /> /* Only the initial value will be displayed. */}
      sx={{
        ...editorStyle,
        ...sx,
      }}
      value={state?.editValue}
    />
  );
};

export default NameField;
